'use client'

import Image from 'next/image'
import { useTranslations } from 'next-intl'

interface JobStat {
    imageSrc: string
    altText: string
    text: string
}

const JobStatItem = ({ imageSrc, altText, text }: JobStat) => (
    <div className="flex flex-col justify-between items-center gap-2 flex-1">
        <Image
            priority={false}
            src={imageSrc}
            alt={altText}
            width={30}
            height={30}
            className="h-[30px] w-auto object-contain"
        />
        <p className="text-center text-[16px] text-black/50 font-medium text-wrap max-w-[160px]">
            {text}
        </p>
    </div>
)

export const JobsNumbers = () => {
    const t = useTranslations()

    const stats: JobStat[] = [
        {
            imageSrc: '/_images/jobs/icons/globe.png',
            altText: 'globe',
            text: t('jobs.numbers.workingFrom'),
        },
        {
            imageSrc: '/_images/jobs/icons/pin.png',
            altText: 'pin',
            text: t('jobs.numbers.nationalities'),
        },
        {
            imageSrc: '/_images/jobs/icons/bar_chart.png',
            altText: 'bar chart',
            text: t('jobs.numbers.femaleEmployees'),
        },
        {
            imageSrc: '/_images/jobs/icons/people.png',
            altText: 'people',
            text: t('jobs.numbers.age'),
        },
    ]

    return (
        <section className="w-full flex items-center justify-center flex-col gap-6 md:gap-12 pb-20 md:pb-28">
            <h1 className="text-center text-[24px] md:text-[32px] font-bold">
                {t('jobs.numbers.title')}
            </h1>
            <div className="flex flex-col md:flex-row gap-12 md:gap-20 ">
                {stats.map((stat, index) => (
                    <JobStatItem key={index} {...stat} />
                ))}
            </div>
        </section>
    )
}
